import { combineActions, handleActions } from 'redux-actions';

import { accountsActions } from '../accounts';
import { resourceStoreTypes, resourceUndoUpserters, resourceUpserters } from '../core';

import { investmentQuotesV2Actions } from '../investment-quotes-v2';
import * as investmentHoldingsV2Selectors from './investmentHoldingsV2Selectors';

import * as actions from './investmentHoldingsV2Actions';
import { INVESTMENT_HOLDINGS_V2_REDUCER_KEY as KEY } from './investmentHoldingsV2Types';

const investmentHoldingsV2Reducer = handleActions(
  {
    [actions.createInvestmentHoldingV2]: (state, { payload: holding }) =>
      resourceUpserters.upsertResource(state, holding),
    [actions.createInvestmentHoldingV2Success]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.deleteInvestmentHoldingV2),

    [actions.updateInvestmentHoldingV2]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.updateInvestmentHoldingV2),
    [actions.updateInvestmentHoldingV2Success]: (state, { payload: holding }) =>
      resourceUpserters.upsertResource(state, holding),

    [actions.batchInvestmentHoldingsV2]: (state, action) =>
      resourceUndoUpserters.upsertResourcesSetupUndo(state, action, actions.batchInvestmentHoldingsV2, false),
    [actions.batchInvestmentHoldingsV2Success]: (state, action) =>
      resourceUndoUpserters.upsertResourcesSetupUndo(state, action, actions.batchInvestmentHoldingsV2, true),

    [actions.deleteInvestmentHoldingV2]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.createInvestmentHoldingV2),
    [actions.deleteInvestmentHoldingV2Success]: (state, { payload: holding }) =>
      resourceUpserters.upsertResource(state, holding),

    [combineActions(
      actions.batchInvestmentHoldingsV2Failure,
      actions.createInvestmentHoldingV2Failure,
      actions.updateInvestmentHoldingV2Failure,
      actions.deleteInvestmentHoldingV2Failure,
    )]: (state, { payload: error, asyncDispatch }) => {
      asyncDispatch(actions.getInvestmentHoldingsV2());
      return resourceUpserters.resetResources(state, error);
    },

    [actions.getInvestmentHoldingsV2]: (state) => state.merge({ isLoading: true }),
    [actions.getInvestmentHoldingsV2Success]: (state, action) => {
      const investmentHoldings = resourceUpserters.upsertResources(state, action.payload);
      const symbols = investmentHoldingsV2Selectors.getSymbols(undefined, investmentHoldings.resourcesById);
      if (symbols.size) {
        action.asyncDispatch(
          investmentQuotesV2Actions.getInvestmentQuotesV2(undefined, {
            axiosConfig: { params: { symbols: symbols.join(',') } },
          }),
        );
      }
      return investmentHoldings;
    },
    [actions.getInvestmentHoldingsV2Failure]: (state, { payload: error }) =>
      resourceUpserters.completeWithError(state, error),

    [accountsActions.applyAccountsChanges]: (state, { payload, asyncDispatch }) => {
      const deletedAccountIds = payload.filter((account) => account.isDeleted).map((account) => account.id);
      if (deletedAccountIds.length) {
        asyncDispatch(actions.getInvestmentHoldingsV2(undefined, { context: 'applyAccountsChanges' })); /// TODO: remove after bump is enabled
        const resourcesById = state.resourcesById.filter((holding) => !deletedAccountIds.includes(holding.accountId));
        return state.merge({ resourcesById });
      }
      return state;
    },
  },
  resourceStoreTypes.mkQcsSyncResourceStore(),
);

export const INVESTMENT_HOLDINGS_V2_REDUCER_KEY = KEY;
export default investmentHoldingsV2Reducer;
